import React, { createContext, useContext } from 'react';

/**
 * Shared handle for the global /create-match accept modal owned by App.js.
 *
 * CreateMatch.jsx calls openMatchAcceptModal({...}) right after a successful
 * POST so the modal shows instantly without waiting for the match_created
 * WebSocket roundtrip. The same call path remains live (App.js still listens
 * via useQueueWebSocket); the context just adds a deterministic local trigger
 * for the creator's own browser.
 *
 * The provider lives in App.js where the modal state actually sits.
 */
const MatchAcceptModalContext = createContext({
  openMatchAcceptModal: () => {},
  closeMatchAcceptModal: () => {},
});

export const MatchAcceptModalProvider = MatchAcceptModalContext.Provider;

export function useMatchAcceptModal() {
  return useContext(MatchAcceptModalContext);
}
